import { InventoryEffect } from './inventory.effect';
import { FleetManagerEffect } from './fleet-manager.effect';
import { OrganizationsEffect } from './organizations.effect';

export const StoreEffects: any[] = [
    InventoryEffect,
    FleetManagerEffect,
    OrganizationsEffect
];
